<script setup lang="ts">
import { stylesText as styles, type IPropSizes, type IPropStyles } from './styles';

interface Props extends IPropStyles, IPropSizes {
  value?: String | string | undefined;
  block?: boolean | undefined;
  disabled?: boolean | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  styleName: 'default'
});
</script>

<template>
  <p
    :class="[
      ('text-auto'),
      (block ? 'w-full' : 'w-fit'),
      ((! disabled) && styles[styleName]),
      (disabled && styles['muted'])
    ]">
    <slot>
      {{ value }}
    </slot>
  </p>
</template>
